<template>
  <div class="h-full max-h-full flex flex-col">
    <h1 class="text-4xl mb-5">Search</h1>
    <transition appear name="efade" mode="out-in">
      <div
        v-if="results.length > 0"
        key="results"
        id="tile-page"
        ref="tiles"
        data-tiles="search"
        class="flex-grow overflow-hidden"
      >
        <scale-grid v-slot="scale" class="mb-16">
          <tile
            v-for="(result, i) in results"
            :class="calculateTileWidth(result, scale.size, scale.full, true)"
            :key="`result_${result.model_type}${result.id}`"
            v-bind="result.tile"
            :info="scale.size < 5 && result.model_type !== 'partner'"
            @click="getAction(result)()"
          />
        </scale-grid>
      </div>
      <div v-else key="no-results" class="no-results flex h-full flex-row items-center justify-center">
        <transition name="efade" mode="out-in">
          <div v-if="loading" class="loader ease-linear">
            <svg xmlns="http://www.w3.org/2000/svg" id="White_Hatch" data-name="White Hatch" viewBox="0 0 283.49 332.3">
              <path
                class="cls-1"
                d="M83.31,1.93a17,17,0,0,1,15.43-.16c.31.15.6.31.9.47l1.29.67,2.57,1.34,5.14,2.69,41.15,21.47,19.53,10.2q4.88,2.55,9.76,5.09l1.22.64.61.33a12.22,12.22,0,0,1,1,.68,11.38,11.38,0,0,1,4.59,8.73c0,.3,0,.59,0,.89v71.59c0,.22,0,.45,0,.67q0,.61-.12,1.23a11.57,11.57,0,0,1-.68,2.45,11.31,11.31,0,0,1-2.94,4.19,11,11,0,0,1-2,1.45L180,137l-1.22.64-2.44,1.27-9.76,5.1-65.25,34-1.28.68-1.1.57c-.39.2-.78.38-1.18.54a15.82,15.82,0,0,1-2.52.83,17.08,17.08,0,0,1-5.38.43,16.85,16.85,0,0,1-5.18-1.25c-.4-.17-.79-.35-1.18-.54l-1.08-.57-1.29-.67L76,175.38,34.82,153.9,15.29,143.71l-4.88-2.55L8,139.88l-1.22-.63c-.3-.16-.61-.31-.9-.48a11.27,11.27,0,0,1-5.69-8.05A9.84,9.84,0,0,1,0,129.49c0-.2,0-.4,0-.6V53.21c0-.58,0-1.15,0-1.73A11.46,11.46,0,0,1,.48,49,11.33,11.33,0,0,1,3,44.57,11.17,11.17,0,0,1,5,42.93a8.54,8.54,0,0,1,1-.64l1.1-.57,1.22-.64L18.07,36Zm-.84,29.86V148.46c0,.47,0,.94,0,1.42,0,.31.06.62.11.93a8.53,8.53,0,0,0,6.05,6.73,8.59,8.59,0,0,0,3.84.19,8.88,8.88,0,0,0,1.82-.55c.38-.16.74-.35,1.11-.55l1.83-1,40.68-21.23,13.39-7L158,124c.39-.2.77-.39,1.15-.61l.71-.44a11.62,11.62,0,0,0,1.35-1.08,11.35,11.35,0,0,0,3.39-6.06,9.65,9.65,0,0,0,.21-1.68c0-.4,0-.79,0-1.18V67.57a11.36,11.36,0,0,0-4.16-8.73,10.87,10.87,0,0,0-1.12-.8c-.53-.34-1.08-.61-1.63-.9l-5.4-2.82-10.8-5.64L120.12,37.41l-14.71-7.68-7.36-3.84-1.84-1-.91-.48-.63-.32a8.51,8.51,0,0,0-12.2,7.66Z"
              />
              <path
                class="cls-1"
                d="M180.26,153.09a17.06,17.06,0,0,1,15.44-.16l.9.47,1.28.67,2.57,1.34,5.15,2.69,41.14,21.47,19.53,10.2,9.76,5.09,1.22.64.61.33c.36.21.7.44,1,.68a11.23,11.23,0,0,1,1.85,1.73,11.22,11.22,0,0,1,2.73,7c0,.3,0,.59,0,.89v71.59c0,.22,0,.45,0,.67,0,.41-.07.82-.13,1.23a11.74,11.74,0,0,1-.68,2.45,11.32,11.32,0,0,1-4.95,5.64l-.81.43-1.22.64-2.44,1.27-9.76,5.1L198.25,329.2l-1.29.67-1.1.58c-.39.19-.78.38-1.18.54a16.83,16.83,0,0,1-7.89,1.26A16.85,16.85,0,0,1,181.6,331q-.6-.25-1.17-.54l-1.09-.57-1.28-.67-5.15-2.68-41.14-21.48-19.53-10.19-4.88-2.55L104.92,291l-1.22-.63c-.3-.16-.61-.31-.9-.48a11.35,11.35,0,0,1-5.69-8.05,10.06,10.06,0,0,1-.14-1.23c0-.2,0-.4,0-.6V204.37c0-.58,0-1.15,0-1.73a10.79,10.79,0,0,1,.46-2.46,11.4,11.4,0,0,1,4.46-6.1,10.06,10.06,0,0,1,1-.63l1.09-.57,1.22-.64,9.76-5.1Zm-61.61,73.18v55.6a11.36,11.36,0,0,0,4.62,9,10.92,10.92,0,0,0,1.42.89l1.54.8L138.55,299l24.65,12.86,12.32,6.43,6.16,3.22,1.54.8c.38.2,1.14.61,1.53.78a8.66,8.66,0,0,0,3.4.7,8.47,8.47,0,0,0,3.4-.72c.37-.16,1.17-.59,1.53-.77l1.54-.81,6.16-3.21,12.32-6.44L237.74,299l12.31-6.43,3.08-1.61,1.54-.8c.37-.2,1.15-.59,1.51-.81a11.38,11.38,0,0,0,4.61-5.12,10.91,10.91,0,0,0,.92-3.35,12,12,0,0,0,.08-1.69V228.77a16.66,16.66,0,0,0-.05-1.73,9,9,0,0,0-.37-1.71,8.7,8.7,0,0,0-1.79-3.07,8.48,8.48,0,0,0-6.2-2.78,8.57,8.57,0,0,0-3.43.68c-.26.11-1.3.62-1.55.74l-1.56.75-6.23,3-24.9,12.05-12.39,6-3.1,1.5-1.55.75-1.54.74a17,17,0,0,1-13.63.3c-.53-.22-1-.46-1.55-.73l-1.55-.81-3.09-1.61-12.4-6.47-24.64-12.87-6.16-3.21-1.54-.81c-.52-.26-1-.54-1.54-.8a8.35,8.35,0,0,0-3.31-.91,8.49,8.49,0,0,0-9.07,8.48Z"
              />
            </svg>
          </div>
          <p v-else>There are no results for the term '{{ searchQuery }}'</p>
        </transition>
      </div>
    </transition>
  </div>
</template>

<script>
import ScaleGrid from '@components/ScaleGrid';
import Tile from '@components/Tile';
import _ from 'lodash';

export default {
  name: 'Search',
  components: { ScaleGrid, Tile },
  data() {
    return {
      searchQuery: this.$route.params.query ?? '',
      results: [],
      loading: true,
    };
  },

  mounted() {
    this.search();

    this.$bus.$on('search-query', (v) => {
      this.loading = true;
      this.searchQuery = v;
      this.search();
    });
  },

  beforeDestroy() {
    this.$bus.$off('search-query');
  },

  methods: {
    search: _.debounce(
      function () {
        if (!this.searchQuery) {
          return this.$router.back();
        }

        this.loading = true;
        axios
          .get(`/api/search?q=${this.searchQuery}`)
          .then((r) => {
            this.results = this.transformResults(r.data);
          })
          .finally(() => {
            this.loading = false;
          });
      },
      250,
      { maxWait: 1000 },
    ),
    transformResults(results) {
      return results
        .map((r) => {
          r.tile = {
            title: this.getTitle(r),
            image: this.getImageUrl(r),
            left: this.getLeft(r),
            right: this.getRight(r),
            tooltip: true,
          };

          return r;
        })
        .sort((a, b) => {
          return a.title.localeCompare(b.title, undefined, {
            numeric: true,
            sensitivity: 'base',
          });
        });
    },
    getAction(result) {
      switch (result.model_type) {
        case 'education':
          return () =>
            this.$router.push({
              name: 'education-detail',
              params: { slug: result.slug, education: result },
            });
        case 'education-masters':
          return () =>
            this.$router.push({
              name: 'education-detail',
              params: { slug: result.slug, education: result },
            });
        case 'education-link':
        case 'partner':
          return () => this.goTo(result.url);
        case 'design':
          return () =>
            this.$router.push({
              name: 'design-detail',
              params: { slug: result.slug, design: result },
            });
        case 'member':
          return () =>
            this.$router.push({
              name: 'team-detail',
              params: { slug: result.slug, team: result },
            });
        case 'news':
          return () =>
            this.$router.push({
              name: 'news-detail',
              params: { slug: result.slug, news: result },
            });
        case 'resource':
        case 'merch':
          return () => this.goTo(result.url);
      }
    },
    getImageUrl(result) {
      switch (result.model_type) {
        case 'member':
          return result.headshot_image.url;
        case 'news':
          return result.main_image.url;
        default:
          return result.is_full_width ? result.banner_image.url : result.tile_image.url;
      }
    },
    getTitle(result) {
      switch (result.model_type) {
        case 'member':
        case 'partner':
          return result.name;
        default:
          return result.title;
      }
    },
    getLeft(result) {
      switch (result.model_type) {
        case 'education':
        case 'education-masters':
        case 'education-link':
          return result.type_string;
        case 'design':
          return result.type;
        case 'member':
          return result.position;
        case 'news':
          return this.formatDate(result.created_at);
        case 'resource':
          return result.type;
        case 'merch':
          return result.merch_type;
        case 'partner':
          return null;
      }
    },
    getRight(result) {
      switch (result.model_type) {
        case 'education':
        case 'education-masters':
        case 'education-link':
        case 'news':
        case 'resource':
          return this.location(result);
        case 'design':
          return result.is_for_sale ? 'For Sale' : 'Not for sale';
        case 'member':
          return result.country;
        case 'partner':
        case 'merch':
          return null;
      }
    },
    location(result) {
      if (result.is_online) {
        return `${result.online_platform}, Online`;
      } else {
        return `${result.city}, ${result.country}`;
      }
    },
  },
};
</script>
